/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FactoringLimit
 */
export interface FactoringLimit {
    /**
     * 
     * @type {Date}
     * @memberof FactoringLimit
     */
    activeSince: Date;
    /**
     * 
     * @type {number}
     * @memberof FactoringLimit
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof FactoringLimit
     */
    available: number;
    /**
     * 
     * @type {number}
     * @memberof FactoringLimit
     */
    used: number;
}

/**
 * Check if a given object implements the FactoringLimit interface.
 */
export function instanceOfFactoringLimit(value: object): value is FactoringLimit {
    if (!('activeSince' in value) || value['activeSince'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    if (!('used' in value) || value['used'] === undefined) return false;
    return true;
}

export function FactoringLimitFromJSON(json: any): FactoringLimit {
    return FactoringLimitFromJSONTyped(json, false);
}

export function FactoringLimitFromJSONTyped(json: any, ignoreDiscriminator: boolean): FactoringLimit {
    if (json == null) {
        return json;
    }
    return {
        
        'activeSince': (new Date(json['activeSince'])),
        'limit': json['limit'],
        'available': json['available'],
        'used': json['used'],
    };
}

export function FactoringLimitToJSON(json: any): FactoringLimit {
    return FactoringLimitToJSONTyped(json, false);
}

export function FactoringLimitToJSONTyped(value?: FactoringLimit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeSince': value['activeSince'].toISOString(),
        'limit': value['limit'],
        'available': value['available'],
        'used': value['used'],
    };
}

